module.exports = __webpack_public_path__ + "static/media/logo.f8cb3593.webp";